import { memo } from "react";
import { HStack } from "@/shared/ui/Stack";
import { ARROW_END_ICONS } from "../../constants/arrowEndIcons";
import { MenuButton } from "../MenuButton/MenuButton";

interface ArrowEndContentProps {
    onClick: (name: string) => void;
}

export const ArrowEndContent = memo(function ArrowEndContent({ onClick }: ArrowEndContentProps) {
    return (
        <HStack gap={4}>
            {Object.entries(ARROW_END_ICONS).map(([name, Icon]) => {
                return (
                    <MenuButton key={name} onClick={() => onClick(name)}>
                        <Icon />
                    </MenuButton>
                );
            })}
        </HStack>
    );
});
